// École Nid Douillet - Internationalization Configuration
// i18next setup for French (default) and Arabic (future)

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frChildren from './locales/fr/children.json';
import frParents from './locales/fr/parents.json';
import frPayments from './locales/fr/payments.json';
import frAnalytics from './locales/fr/analytics.json';
import frSettings from './locales/fr/settings.json';

const resources = {
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    children: frChildren,
    parents: frParents,
    payments: frPayments,
    analytics: frAnalytics,
    settings: frSettings,
  },
  // Arabic translations will be added in Phase 2
  // ar: {
  //   common: arCommon,
  //   auth: arAuth,
  //   // ... other namespaces
  // }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ecole-language',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Development options
    debug: false,
    
    // React options
    react: {
      useSuspense: false,
    },

    // Backend options (for loading translations from server in future)
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
